// Get the image element
const image = document.querySelector(".ccm-lightcase img");
// each image
const images = document.querySelectorAll(".ccm-lightcase img");
if(images.length){

    let imgs = [];
    let galleryTitle = '';

    // Get all srcs
    images.forEach((img) => img.closest('.ccm-lightcase') ? imgs.push(img.closest('.ccm-lightcase').getAttribute('data-src')) : '');

    images.forEach(image => {
        // Add a click event listener to the image element
        image.addEventListener("click", function() {
           
            // Create the overlay element and append it to the document body
            const overlay = document.createElement("div");
            overlay.id = "overlay";
            overlay.style.backgroundColor = "rgba(0, 0, 0, 1)";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            overlay.style.width = "100%";
            overlay.style.height = "100%";
            overlay.style.zIndex = "1030";
            overlay.style.overflow = "auto";
            document.body.appendChild(overlay);
            
            //   parent closest ccm-lightcase
            const parent = image.closest('.ccm-lightcase');
            // data-src
            const dataSrc = parent.getAttribute('data-src');
            galleryTitle = parent.getAttribute('data-title');
            // console.log(dataSrc);
            // console.log(imgs);

            let imgsHtml = '';
            if(imgs.length){
                imgs.forEach((img, index) => {
                    imgsHtml += `<div class="keen-slider__slide d-flex align-items-center justify-content-center flex-shrink-0 w-100 vw-100" style=""><img class="img-fluid mw-100 mw-lg-50" src="${img}" style="object-fit:contain;max-height:600px" /></div>`;
                });
            }
            
            // Create the gallerybox element and append it to the overlay element
            const gallerybox = document.createElement("div");
            gallerybox.id = "gallerybox";
            gallerybox.style.display = "flex";
            gallerybox.style.justifyContent = "center";
            gallerybox.style.height = "100%";
            gallerybox.style.alignItems = "center";
            gallerybox.innerHTML = `<div class="overlay-trigger position-absolute top-0 start-0 h-100 w-100" style="z-index:1030"></div>
                                    <div class="d-flex flex-row align-items-center position-absolute top-0 start-0 w-100" style="z-index:1040">
                                        <div class="fs-md fw-medium text-gray p-3"><span class="current-index"></span> / ${imgs.length}</div>
                                        <div class="ms-auto">
                                            <button type="button" class="btn bg-transparent btn-x p-3 text-gray"><i class="far fa-close fs-5 px-1"></i></button>
                                        </div>
                                    </div>
                                    <div class="position-relative text-center d-flex" style="max-width: 90%; max-height: 90vh; z-index: 1040;">
                                        <div id="gbox-slider" class="keen-slider h-100">${imgsHtml}</div>
                                        <div class="placeholder"><img src="${dataSrc}" class="img-fluid "></div>
                                    </div>
                                    <button type="button" class="btn text-white gbox-prev position-absolute start-0 top-0 bottom-0 my-auto ms-lg-5 p-2" style="background-color:rgba(0,0,0,0.8);border-top-right-radius: 50%;border-bottom-right-radius: 50%;height:50px;z-index:1050;"><i class="fal fa-arrow-left fs-5 fs-lg-4"></i></button>
                                    <button type="button" class="btn text-white gbox-next position-absolute end-0 top-0 bottom-0 my-auto me-lg-5 p-2" style="background-color:rgba(0,0,0,0.8);border-top-left-radius: 50%;border-bottom-left-radius: 50%;height:50px;z-index:1050"><i class="fal fa-arrow-right fs-5 fs-lg-4"></i></button>
                                    <div class="d-flex flex-row align-items-center position-absolute bottom-0 start-0 w-100 p-3" style="z-index:1040">
                                        <div class="fs-lg fw-medium text-gray p-3 mx-auto"><span class="current-title"></span></div>
                                    </div>
                                    `;
            overlay.appendChild(gallerybox);

            // Add zooming and dragging functionality to the image
            gallerybox.addEventListener('click', function(e) {
                if (e.target.tagName === 'IMG') {
                    if (e.target.classList.contains('zoomed')) {
                        e.target.style.transform = "scale(1)";
                        e.target.style.transition = "transform 0.25s ease";
                        e.target.classList.remove('zoomed');
                    } else {
                        // Calculate click coordinates within the image
                        const rect = e.target.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const y = e.clientY - rect.top;
            
                        // Set the transform-origin to the click coordinates
                        e.target.style.transformOrigin = `${x}px ${y}px`;
            
                        e.target.style.transform = "scale(2)";
                        e.target.style.transition = "transform 0.25s ease";
                        e.target.classList.add('zoomed');
                    }
                }
            });

            // Create a new instance of Hammer with the gallerybox as the target element
            const hammer = new Hammer(gallerybox);

            // Add a Pinch recognizer
            hammer.get('pinch').set({ enable: true });

            // Handle pinchstart events
            hammer.on('pinchstart', function(e) {
                // Save the initial scale
                e.target.initialScale = e.target.style.transform ? parseFloat(e.target.style.transform.split('(')[1]) : 1;
            });

            // Handle pinchmove events
            hammer.on('pinchmove', function(e) {
                // Calculate the new scale
                const scale = e.target.initialScale * e.scale;

                // Get the position of the element
                const rect = e.target.getBoundingClientRect();

                // Convert the center of the pinch from page coordinates to element coordinates
                const originX = (e.center.x - rect.left) / scale;
                const originY = (e.center.y - rect.top) / scale;

                // Set the transform-origin to the center of the pinch
                e.target.style.transformOrigin = `${originX}px ${originY}px`;

                // Apply the new scale
                e.target.style.transform = `scale(${scale})`;
            });

            // Handle pinchend events
            hammer.on('pinchend', function(e) {
                // If the image is zoomed out too much, reset its scale to 1
                if (e.target.style.transform && parseFloat(e.target.style.transform.split('(')[1]) < 1) {
                    e.target.style.transform = 'scale(1)';
                }
            });
            
            // animate popup fadein
            overlay.animate(
                [
                    // keyframes
                    { opacity: '0' },
                    { opacity: '.5' },
                    { opacity: '1' }
                ], {
                    // timing options
                    duration: 300,
                    iterations: 1
                }
            );
        
            // Add a click event listener to the overlay element to remove the gallerybox and overlay
            const overlayTrigger = overlay.querySelector('.overlay-trigger');
            const btnClose = gallerybox.querySelector('.btn-x');
            if(btnClose){
                overlayTrigger.addEventListener("click", () => { hideGbox(overlay) });
                btnClose.addEventListener("click", () => { hideGbox(overlay) });
            }

            // Build the slider - keen-slider is needed for this
            if(typeof KeenSlider === 'function'){
                let currentIndex = imgs.indexOf(dataSrc);
                currentIndex = currentIndex > -1 ? currentIndex : 0;
                gallerybox.querySelector('.current-index').innerHTML = `${currentIndex + 1}`;
                if(galleryTitle){
                    gallerybox.querySelector('.current-title').innerHTML = `${galleryTitle}`;
                }
                gallerybox.querySelector('.placeholder').remove();
                let gBoxSlider = new KeenSlider("#gbox-slider", {
                    loop: true,
                    initial: currentIndex,
                    mode: "snap",
                    drag: false,
                    slides: {
                        perView: 1,
                        origin: 'center',
                    }
                }, [
                    slider => {
                        slider.on("slideChanged", () => {
                            gallerybox.querySelector('.current-index').innerHTML = `${slider.track.details.rel + 1}`;
                        });

                        const prev = document.querySelector('.gbox-prev')

                        if(images.length < 2){
                            prev.style.display = 'none';
                        }

                        prev.onclick = (e) => {
                            e.preventDefault()

                            slider.prev()
                        }

                        const next = document.querySelector('.gbox-next')

                        if(images.length < 2){
                            next.style.display = 'none';
                        }

                        next.onclick = (e) => {
                            e.preventDefault()

                            slider.next()
                        }
                    }
                ])
            }
            
        });
    });

    // Hide box
    const hideGbox = (overlay) => {
        overlay.animate(
            [
                { opacity: '1' },
                { opacity: '.5' },
                { opacity: '0' }
            ], {
                duration: 300,
                iterations: 1
            }
        );
        document.body.removeChild(overlay);
    }
}
